import React from 'react';
import { useHistory } from 'react-router-dom';
import { routeConstants } from 'routes';
import { TipCalculationsTab } from 'types';
import { StyledTabNav, StyledTabNavItem } from '../../shared/styles';

interface ITabNavProps {
  activeTab: TipCalculationsTab;
}

export const TabNav = ({ activeTab }: ITabNavProps) => {
  const history = useHistory();
  const handleTabChange = (tab: TipCalculationsTab) => {
    history.push({ pathname: `${routeConstants.private.settingsCalculator}/${tab}` });
  };

  return (
    <StyledTabNav data-cy="calculator-tab-nav">
      <StyledTabNavItem label="Tip Shares" isActive={activeTab === TipCalculationsTab.TIP_SHARES} onClick={() => handleTabChange(TipCalculationsTab.TIP_SHARES)} />
      <StyledTabNavItem label="Default Pool" isActive={activeTab === TipCalculationsTab.DEFAULT_POOL} onClick={() => handleTabChange(TipCalculationsTab.DEFAULT_POOL)} />
      <StyledTabNavItem label="Point Values" isActive={activeTab === TipCalculationsTab.POINT_VALUES} onClick={() => handleTabChange(TipCalculationsTab.POINT_VALUES)} />
    </StyledTabNav>
  );
};
